// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kore-chat-window .minitableDiv {
  clear: both;
  border-radius: 4px;
  background-color: var(--sdk-chat-window-bot-bubble-bg);
  margin-top: 10px;
  box-shadow: 0 1px 7px 0 rgba(157, 157, 157, 0.58);
}

.kore-chat-window .minitableDiv table {
  width: 100%;
}

.kore-chat-window .minitableDiv table th {
  text-align: left;
  padding: 10px;
  font-size: 15px;
  color: var(--sdk-chat-window-bot-bubble-font-clr);
  font-weight: bold;
}

.kore-chat-window .minitableDiv table td {
  text-align: left;
  padding: 10px;
  text-align: left;
  padding: 10px;
  font-size: 15px;
  color: #8a959f;
  max-width: 190px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/*.kore-chat-window .tablechart .tablechartDiv,
.kore-chat-window .largePreviewContent .tablehartDiv {
    clear: both;
    left: -30px;
    position: relative;
    top: 18px;
    margin: 0px -22px 13px 0px;
    border-radius: 4px;
    background-color: var(--sdk-chat-widow-default-white);
    box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);
}

.kore-chat-window .tablechartDiv table {
    border-collapse: collapse;
}

.kore-chat-window .tablechartDiv tr {
    border-bottom: 1px solid #dfdfdf;
}

.kore-chat-window .tablechartDiv tr.headerTitle {
    border-bottom: solid 1px #99ed9e;
}

.kore-chat-window .tablechart .tablechartDiv tr.bottomThickBorder,
.kore-chat-window .largePreviewContent .tablechartDiv tr.bottomThickBorder {
    border-bottom: 3px solid #d6d6d6;
}

.kore-chat-window .tablechart .profile-photo {
    top: 30px;
}

.kore-chat-window .kore-chat-window.expanded .tablechart .profile-photo {
    top: 30px;
}

.kore-chat-window .tablechart .tablechartDiv table,
.kore-chat-window .largePreviewContent .tablechartDiv table {
    width: 100%;
}
.kore-chat-window .tablechart .tablechartDiv table td,
.kore-chat-window .tablechart .tablechartDiv table th {
    padding: 10px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 200px;
    font-size: 14px;
    color: var(--sdk-chat-widow-primary-font-color);
    text-align: left;
}

.kore-chat-window .largePreviewContent .tablechartDiv table td,
.kore-chat-window .largePreviewContent .tablechartDiv table th {
    padding: 17px;
    /* white-space: nowrap; */
/* font-size: 14px;
    color: var(--sdk-chat-widow-primary-font-color);
    text-align: left;
    max-width: 200px;
}

.kore-chat-window .tablechart tr:last-child,
.kore-chat-window .largePreviewContent tr:last-child {
    border: none;
}
.kore-chat-window .messageBubble.tableChart {
    margin-bottom: 10px;
}

.kore-chat-window #myPreviewModal .tablechartDiv .hide {
    display: table-row;
}

.kore-chat-window #myPreviewModal .tablechartDiv .showMore {
    display: none;
}
.kore-chat-window .largePreviewContent .tablechartDiv {
    display: block;
    background: var(--sdk-chat-widow-default-white);
    padding: 10px;
    border: 30px solid var(--sdk-chat-widow-primary-bg-color);
    border-top: 52px solid var(--sdk-chat-widow-primary-bg-color);
}
.kore-chat-window .messageBubble.tableChart {
    margin-bottom: 10px;
}

[dir="rtl"].kore-chat-window .tablechart .tablechartDiv{
    right: 20px;
    width: 100%;
}
*/`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/miniTableTemplate/miniTableTemplate.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,kBAAA;EACA,sDAAA;EACA,gBAAA;EACA,iDAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,gBAAA;EACA,aAAA;EACA,eAAA;EACA,iDAAA;EACA,iBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6BAAA;AAyDG;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAAA","sourcesContent":[".kore-chat-window .minitableDiv {\n    clear: both;\n    border-radius: 4px;\n    background-color: var(--sdk-chat-window-bot-bubble-bg);\n    margin-top: 10px;\n    box-shadow: 0 1px 7px 0 rgba(157, 157, 157, 0.58);\n}\n\n.kore-chat-window .minitableDiv table {\n    width: 100%;\n}\n\n.kore-chat-window .minitableDiv table th {\n    text-align: left;\n    padding: 10px;\n    font-size: 15px;\n    color: var(--sdk-chat-window-bot-bubble-font-clr);\n    font-weight: bold;\n}\n\n.kore-chat-window .minitableDiv table td {\n    text-align: left;\n    padding: 10px;\n    text-align: left;\n    padding: 10px;\n    font-size: 15px;\n    color: #8a959f;\n    max-width: 190px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/*.kore-chat-window .tablechart .tablechartDiv,\n.kore-chat-window .largePreviewContent .tablehartDiv {\n    clear: both;\n    left: -30px;\n    position: relative;\n    top: 18px;\n    margin: 0px -22px 13px 0px;\n    border-radius: 4px;\n    background-color: var(--sdk-chat-widow-default-white);\n    box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);\n}\n\n.kore-chat-window .tablechartDiv table {\n    border-collapse: collapse;\n}\n\n.kore-chat-window .tablechartDiv tr {\n    border-bottom: 1px solid #dfdfdf;\n}\n\n.kore-chat-window .tablechartDiv tr.headerTitle {\n    border-bottom: solid 1px #99ed9e;\n}\n\n.kore-chat-window .tablechart .tablechartDiv tr.bottomThickBorder,\n.kore-chat-window .largePreviewContent .tablechartDiv tr.bottomThickBorder {\n    border-bottom: 3px solid #d6d6d6;\n}\n\n.kore-chat-window .tablechart .profile-photo {\n    top: 30px;\n}\n\n.kore-chat-window .kore-chat-window.expanded .tablechart .profile-photo {\n    top: 30px;\n}\n\n.kore-chat-window .tablechart .tablechartDiv table,\n.kore-chat-window .largePreviewContent .tablechartDiv table {\n    width: 100%;\n}\n.kore-chat-window .tablechart .tablechartDiv table td,\n.kore-chat-window .tablechart .tablechartDiv table th {\n    padding: 10px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    max-width: 200px;\n    font-size: 14px;\n    color: var(--sdk-chat-widow-primary-font-color);\n    text-align: left;\n}\n\n.kore-chat-window .largePreviewContent .tablechartDiv table td,\n.kore-chat-window .largePreviewContent .tablechartDiv table th {\n    padding: 17px;\n    /* white-space: nowrap; */\n   /* font-size: 14px;\n    color: var(--sdk-chat-widow-primary-font-color);\n    text-align: left;\n    max-width: 200px;\n}\n\n.kore-chat-window .tablechart tr:last-child,\n.kore-chat-window .largePreviewContent tr:last-child {\n    border: none;\n}\n.kore-chat-window .messageBubble.tableChart {\n    margin-bottom: 10px;\n}\n\n.kore-chat-window #myPreviewModal .tablechartDiv .hide {\n    display: table-row;\n}\n\n.kore-chat-window #myPreviewModal .tablechartDiv .showMore {\n    display: none;\n}\n.kore-chat-window .largePreviewContent .tablechartDiv {\n    display: block;\n    background: var(--sdk-chat-widow-default-white);\n    padding: 10px;\n    border: 30px solid var(--sdk-chat-widow-primary-bg-color);\n    border-top: 52px solid var(--sdk-chat-widow-primary-bg-color);\n}\n.kore-chat-window .messageBubble.tableChart {\n    margin-bottom: 10px;\n}\n\n[dir=\"rtl\"].kore-chat-window .tablechart .tablechartDiv{\n    right: 20px;\n    width: 100%;\n}\n*/"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
